<template>
    <div 
        class="m-input-form input-form"
        :class="{'input-form--invalid': !isValid}"
    >
        <div class="input-form__icon">
            <slot name="icon" />
        </div>
        <AInput
            :value="value"
            :placeholder="placeholder"
            disabled
        />
        <ADeleteButton
            :text="$t('ui.delete')"
            @onClick="onDelete"
        />
    </div>
</template>

<script>
import AInput from '../../atoms/a-input/a-input';
import ADeleteButton from '../../atoms/a-delete-button/a-delete-button';

export default {
    name: 'MInputForm',
    components: {
        AInput,
        ADeleteButton
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        icon: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: ''
        },
        isValid: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        onDelete() {
            this.$emit('onDelete', true);
        },
        onChange() {
            this.$emit('onChange', true);
        }
    }
}
</script>

<style lang="scss">
@import "m-input-form";
</style>
